import { render } from "./icon.vue?vue&type=template&id=a8d0bbb6"
import script from "./icon.vue?vue&type=script&lang=js"
export * from "./icon.vue?vue&type=script&lang=js"

import "./icon.vue?vue&type=style&index=0&id=a8d0bbb6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__